import classNames from 'classnames'
import React from 'react'
import { lightGreen, lightRed, secondary } from 'styles'

import { makeStyles } from '@mui/styles'

const useStyles = makeStyles({
  equal: {
    color: secondary,
    fontWeight: '700',

    '&&': {
      marginLeft: '0.1rem',
    },
  },
  icon: {},
  negative: {
    color: lightRed,
  },
  positive: {
    color: lightGreen,
  },
})

export interface InfoArrowProps {
  className?: string
  current?: number | null
  compared?: number | null
  percent?: number | null
}

export function InfoArrow({ className = '', current, compared, percent }: InfoArrowProps) {
  const classes = useStyles()

  const showDash = (current && compared && current === compared) || percent === 0
  const showArrowUp = (current && compared && current > compared) || (percent && percent > 0)
  const showArrowDown = (current && compared && current < compared) || (percent && percent < 0)

  if (showArrowUp) return <i className={classNames('fm fm-arrow-up', className, classes.icon, classes.positive)} />
  if (showArrowDown) return <i className={classNames('fm fm-arrow-down', className, classes.icon, classes.negative)} />
  if (showDash) return <i className={classNames(className, classes.icon, classes.equal)}>-</i>

  return null
}
